<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">{{ $route.meta.title || '' }}</h3>
    </div>
  <!-- <v-breadcrumbs divider="-" :items="breadcrumbs">
        <template v-slot:item="props">
        <a :href="props.item.href" :class="[props.item.disabled && 'disabled']">{{ props.item.text}}</a>
      </template>
    </v-breadcrumbs>-->
    <v-spacer></v-spacer>
    <div class="page-header-right">
      <v-btn icon>
        <v-icon @click="refresh" class="text--secondary">refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
  const axios = require('axios');
  import moment from 'moment'
export default {
  data() {
    return {
      title: "Home",
      breadcrumbs: [
      ]
    }
  },
  watch: {
    '$route.path': function (newVal) {
      this.computeBreadcrumbs()
    }
  },
  methods: {
refresh(){
   function getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    }
     var data=this;
     var jwt = getCookie('jwt');
  axios.post('http://'+location.hostname+'/validation_token.php', {
           jwt :jwt, 
    })
  .then(function (response) {
    if(response.data.message=="access"){
     // data.store.state.routes = JSON.parse(response.data.routes);
    //  data.store.state.cars = JSON.parse(response.data.cars);
      //data.store.state.places = JSON.parse(response.data.places);
    } else if(response.data.message=="denied"){
   //   this.delete_cookie("jwt");
      data.$router.push('/auth/login');
    }
  })
},
    computeBreadcrumbs () {
      let  breadcrumbs = [
        {
          text: "Home",
          href: "/",
          disabled: false
        }
      ];
      let appends = []
      appends = this.$route.matched.map( item => {
        return {
          text: item.meta.title || "",
          href: item.path || "/",
          disabled: item.path === this.$route.path
        }
      })
      this.breadcrumbs = breadcrumbs.concat(appends)
    }
  },
  created () {
    this.computeBreadcrumbs()
  }
}
</script>
<style lang="stylus" scoped>
  .disabled
    color: grey
    pointer-events: none
    text-decoration: blink
</style>